module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume006.6b2ac5c9.webp";